import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a4jfr5nd76: FaireBrandEntity = {
  token: "b_a4jfr5nd76",
  type: "brand",
  name: "Oilogic Baby & Kid Solutions",
  avatarUrl:
    "https://cdn.faire.com/fastly/397d5050a607291a7c5788e338645a710c8f445dce0f7e94dd3d11613a18a379.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b42968ab745209e2e79601089a05a7e13ffd9374b51fc315d19362500cfcebd1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/397d5050a607291a7c5788e338645a710c8f445dce0f7e94dd3d11613a18a379.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b42968ab745209e2e79601089a05a7e13ffd9374b51fc315d19362500cfcebd1.jpeg",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "Solutions for Baby. Lifesaver for Parents. Founded, owned and operated by two Moms who wanted more natural product solutions to help take care of their little one., Oilogic Baby & Kid Solutions use the natural power of Essential Oils and other clean ingredients to help your little one with everyday issues. We want to take the stress out of stressful situations like the bedtime routine, when baby isn't feeling well or even an itchy bug bite. Our personal care products include body oils, bath products, linen mists and more and use 100% pure essential oil blends that help soothe and comfort. All of our products are Pediatrician & Dermatologist Tested, Cruelty Free, and made without petroleum, phthalates, parabens, sodium lauryl sulfate, gluten, DEA, dyes, mineral oil, artificial colors, synthetic fragrance. \n\nOilogic product may not be sold on Amazon.com or any other 3rd party online marketplace without our consent.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.840Z",
    importedBy: "entity-db-cli",
  },
};
